<app-site-settings-menu>
    <div class="integration-editor-page">

        <ng-container *ngIf="isCreateMode; else editMode">
            <header class="page-header">
                <button mat-icon-button class="back-button" appPreventDoubleClick (throttledClick)="navigateBack()" aria-label="Back to integrations" matTooltip="Back to integrations">
                    <mat-icon aria-hidden="false" class="material-icons-outlined">arrow_back</mat-icon>
                </button>

                <div class="title-block">
                    <h1 appLocalizationPopupDirective localizationCode="Integrations-Create">{{ 'Integrations-Create' | translate: {Default: "Create New Integration"} }}</h1>
                    <p class="subtitle">{{ 'Integrations-CreateHint' | translate: {Default: "Choose the type of integration and describe it. You'll set up its connection on the next step."} }}</p>
                </div>
            </header>

            <section class="surface">
                <app-integration-general-tab
                    (created)="onIntegrationCreated($event)"
                    (cancelled)="navigateBack()"
                ></app-integration-general-tab>
            </section>
        </ng-container>

        <ng-template #editMode>
            <ng-container *ngIf="integrationSettings; else notLoaded">
                <header class="page-header">
                    <button mat-icon-button class="back-button" appPreventDoubleClick (throttledClick)="navigateBack()" aria-label="Back to integrations" matTooltip="Back to integrations">
                        <mat-icon aria-hidden="false" class="material-icons-outlined">arrow_back</mat-icon>
                    </button>

                    <div class="avatar" aria-hidden="true">{{ integrationInitial }}</div>

                    <div class="title-block">
                        <div class="title-row">
                            <h1>{{ integrationSettings.integration.name }}</h1>
                            <span class="status-pill" [class.active]="integrationSettings.status">
                                <ng-container *ngIf="integrationSettings.status; else inactive">{{ 'Active' | translate: {Default: 'Active'} }}</ng-container>
                                <ng-template #inactive>{{ 'Inactive' | translate: {Default: 'Inactive'} }}</ng-template>
                            </span>
                        </div>
                        <p class="subtitle" *ngIf="description">{{ description }}</p>
                    </div>

                    <app-integration-actions
                        class="header-actions"
                        [integrationId]="integrationSettings.id"
                        [integrationType]="integrationSettings.integration.id"
                        (result)="actionResult = $event"
                    ></app-integration-actions>
                </header>

                <div class="result-banner" *ngIf="actionResult" [ngClass]="actionResult.success ? 'success' : 'error'" role="status">
                    <mat-icon class="material-icons-outlined">{{ actionResult.success ? 'check_circle' : 'error' }}</mat-icon>
                    <div class="result-text">
                        <strong>{{ actionResult.title }}</strong>
                        <span *ngIf="actionResult.message">{{ actionResult.message }}</span>
                    </div>
                    <button mat-icon-button appPreventDoubleClick (throttledClick)="actionResult = null" aria-label="Dismiss">
                        <mat-icon class="material-icons-outlined">close</mat-icon>
                    </button>
                </div>

                <app-integration-tab-container
                    [integrationSettings]="integrationSettings"
                    [initialTabIndex]="initialTabIndex"
                    (settingsSaved)="onSettingsSaved()"
                ></app-integration-tab-container>
            </ng-container>

            <ng-template #notLoaded>
                <div class="empty-state" *ngIf="loadFailed; else loading">
                    <p>{{ 'Integrations-ErrorLoading' | translate: {Default: 'Unable to load this integration.'} }}</p>
                    <button mat-stroked-button appPreventDoubleClick (throttledClick)="navigateBack()">
                        {{ 'Integrations-BackToList' | translate: {Default: 'Back to integrations'} }}
                    </button>
                </div>

                <ng-template #loading>
                    <ngx-skeleton-loader
                        count="5"
                        [theme]="{
                            'height.px': 50
                        }"
                    ></ngx-skeleton-loader>
                </ng-template>
            </ng-template>
        </ng-template>

    </div>
</app-site-settings-menu>
